import { TFunction } from 'i18next';
import { MenuConfig } from '../lib/components';
import { DashboardIcon, DownloadArrowIcon, SaveIcon } from '../lib/icons';

export const exportsSubmenuConfig = (t: TFunction): MenuConfig => {
  return [
    {
      title: t('common:OVERVIEW'),
      isActive: ({ pathname }) => /\/exports\/overview/.test(pathname),
      icon: DashboardIcon,
      link: `/exports/overview`
    },
    {
      title: t('common:IMPORTS'),
      isActive: ({ pathname }) => /\/imports/.test(pathname),
      icon: SaveIcon,
      link: `/imports`
    },
    {
      title: t('common:EXPORTS'),
      isActive: ({ pathname }) => /\/exports(?!\/)/.test(pathname),
      icon: DownloadArrowIcon,
      link: `/exports`
    }
  ];
};
